import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { routes as appRoutes } from "./Routes";
import Map from './components/Map';
import './lib/App.css';


function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Map />} />
        {appRoutes.map((route) => (
          <Route
            key={route.key}
            path={route.path}
            element={<Map />}
          />
        ))}
        {/* fallback for unmatched routes */}
        <Route path="*" element={<Map />} />
      </Routes>
    </Router>
  );
}

export default App;